import * as React from "react";
import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import DataLakeWidgetConfig from "data-lake/logic/DataLakeWidgetConfig";
import PreviewLayoutContext from "../../../contexts/PreviewLayoutContext";
const WidgetEditInfo = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "internal_layout.widget_edit_info",
      components: {
        italic: /* @__PURE__ */ React.createElement("i", null),
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.DATA_LAKE, text: t("internal_layout.documentation") })
      }
    }
  ));
};
const PreviewLayoutProvider = ({ children }) => {
  const contextValue = useMemo(
    () => ({
      widgetEdit: {
        formInfo: /* @__PURE__ */ React.createElement(WidgetEditInfo, null),
        showFieldSelect: true,
        fieldsCreationAllowed: true
      },
      defaultFields: DataLakeWidgetConfig.defaultFields
    }),
    []
  );
  return /* @__PURE__ */ React.createElement(PreviewLayoutContext.Provider, { value: contextValue }, children);
};
export default PreviewLayoutProvider;
